import React from 'react';
import { Send, Mail, MapPin } from 'lucide-react';

const ContactInfo = () => (
  <div className="bg-card border border-border p-6 rounded-lg">
    <h3 className="text-xl font-bold mb-6">Get in Touch</h3>
    <div className="space-y-6">
      <div className="flex items-start gap-4">
        <div className="bg-primary/10 p-3 rounded-lg text-primary">
          <Mail size={20} />
        </div>
        <div>
          <h4 className="font-medium mb-1">Email</h4>
          <p className="text-sm text-muted-foreground">support@supertags.com</p>
        </div>
      </div>
      <div className="flex items-start gap-4">
        <div className="bg-primary/10 p-3 rounded-lg text-primary">
          <MapPin size={20} />
        </div>
        <div>
          <h4 className="font-medium mb-1">Office</h4>
          <p className="text-sm text-muted-foreground">123 Creator St, Tech Valley, CA 94000</p>
        </div>
      </div>
    </div>
  </div>
);

const ContactForm = ({ formData, handleChange, handleSubmit, loading }) => (
  <form onSubmit={handleSubmit} className="space-y-6">
    <div className="space-y-2">
      <label className="text-sm font-medium">Name</label>
      <input 
        required
        name="name"
        type="text" 
        className="w-full bg-background border border-input p-3 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none"
        placeholder="Your name"
        value={formData.name}
        onChange={handleChange}
      />
    </div>
    <div className="space-y-2">
      <label className="text-sm font-medium">Email</label>
      <input 
        required
        name="email"
        type="email" 
        className="w-full bg-background border border-input p-3 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none"
        placeholder="your@email.com"
        value={formData.email}
        onChange={handleChange}
      />
    </div>
    <div className="space-y-2">
      <label className="text-sm font-medium">Message</label>
      <textarea 
        required
        name="message"
        rows={5}
        className="w-full bg-background border border-input p-3 rounded-lg focus:ring-2 focus:ring-accent focus:outline-none resize-none"
        placeholder="How can we help?"
        value={formData.message}
        onChange={handleChange}
      />
    </div>
    <button 
      type="submit" 
      disabled={loading}
      className="w-full bg-primary text-primary-foreground font-bold py-4 rounded-lg hover:opacity-90 transition-opacity flex items-center justify-center gap-2"
    >
      {loading ? 'Sending...' : <><Send size={18} />Send Message</>}
    </button>
  </form>
);

export { ContactInfo, ContactForm };